import { insightsService } from "@/services/insightsService";
import { WeeklyInsightData } from "@/components/dashboard/DashboardInsights";

export const fetchWeeklyInsights = async (
  userId: string,
  teamId: string | null
): Promise<WeeklyInsightData> => {
  try {
    // Use getPatterns to get pattern data and transform it to WeeklyInsightData format
    const patterns = await insightsService.getPatterns(7);

    // Map backend PatternPrediction format to WeeklyInsightData format
    const energyTrend = patterns?.energyPatterns?.trend || 'stable';
    const avgEnergy = patterns?.energyPatterns?.averageEnergy || 50;
    
    // Calculate energy change percentage based on trend
    let energyPercentageChange = 0;
    if (energyTrend === 'improving') {
      energyPercentageChange = 10;
    } else if (energyTrend === 'declining') {
      energyPercentageChange = -10;
    }

    // Transform to WeeklyInsightData format
    const weeklyData: WeeklyInsightData = {
      tone: {
        positive: avgEnergy >= 60 ? 60 : avgEnergy >= 40 ? 40 : 20,
        neutral: 30,
        negative: avgEnergy < 40 ? 40 : avgEnergy < 60 ? 20 : 10,
      },
      topThemes: (patterns?.behavioralPatterns?.successFactors || []).slice(0, 3).map((factor: string, index: number) => ({
        name: factor,
        count: 5 - index,
      })),
      weeklyChanges: {
        energy: energyPercentageChange,
        focus: 0,
      },
      focusPatterns: {
        peakTimeRange: patterns?.energyPatterns?.peakTimes?.[0] || "9 AM - 11 AM",
        recommendation: patterns?.predictions?.suggestedAdjustments?.[0] || "Try scheduling focused work during your peak energy times.",
      },
      energyTrend: {
        percentageChange: energyPercentageChange,
        message: energyTrend === 'improving' 
          ? "Your energy levels are trending upward!" 
          : energyTrend === 'declining'
          ? "Your energy levels have been lower recently."
          : "Your energy levels have been consistent.",
      },
      upcomingActivities: {
        count: 0,
        message: "Check your calendar for upcoming activities.",
      },
      weeklySummary: {
        text: patterns?.burnoutRisk?.recommendations || ["Keep up your current momentum!"],
        recommendation: patterns?.predictions?.nextWeekOutlook || "Stay focused on your goals and take regular breaks.",
      },
    };

    return weeklyData;
  } catch (error) {
    console.error("Error fetching weekly insights:", error);
    throw error;
  }
};
